import React from "react";
import {Link} from "react-router-dom";

class RentBanner extends React.Component {
  render() {
    return (
        <section className="header_section header_section_buy">
          {/* <div className="bg-overlay" / >*/}
          <div className="container">
            <div className="row">

              <div className="col-lg-8">
                <div className="desktop-header">
                  <h5 className="mb-2 SansSerif bold600">New Generation of Global Wifi</h5>
                  <h1 className="sub no-margin bold600 mb-3">MightyWifi Cloud</h1>
                  <div className="col-md-12" style={{ clear: "both", height: "20px" }} />
                  <div className="row">
                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-box">
                            <div className="icon unlimited"></div>
                          </div>
                        </div>
                        <div className="col-md-9 icon-text-box">
                        <span className="icon-text">
                        {/*<strong>Unlimited data</strong><br/>
                        Never worry about running out of data*/}
                          <strong>Flexible Data Options</strong><br/>
                        No contracts, pay as you need. Flexible data size plans available
                        </span>
                        </div>

                        <div className="col-md-12" style={{ clear: "both", height: "20px" }} />

                        <div className="col-md-3">
                          <div className="icon-box">
                            <div className="icon hub"></div>
                          </div>
                        </div>
                        <div className="col-md-9 icon-text-box">
                        <span className="icon-text">
                        <strong>Easy and Secure</strong><br/>
                        SIM-Free, Hassle-Free
                        </span>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="row">
                        <div className="col-md-3">
                          <div className="icon-box">
                            <div className="icon global"></div>
                          </div>
                        </div>
                        <div className="col-md-9 icon-text-box">
                        <span className="icon-text">
                        <strong>Wifi over</strong><br/>
                        150 Countries
                        </span>
                        </div>

                        {/*<div className="col-md-12" style={{ clear: "both", height: "20px" }} />

                      <div className="col-md-3">
                      <div className="icon-box">
                        <div className="icon share"></div>
                      </div>
                      </div>
                      <div className="col-md-9 icon-text-box">
                        <span className="icon-text">
                        <strong>US Data Plan Including Canada and Mexico</strong><br/>
                        Purchase a US data plan to use in Canada and Mexico with no extra cost
                        </span>
                      </div>*/}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4"></div>



              {/*
            <div className="mobile-header">
              <h2 className="SansSerif bold600 m-title-positon">
                <span className="line-break m-header-mtitle Serif">Coming Soon</span>
                <span className="line-break m-header-stitle">2ND generation of global wifi hotspot</span>
                MightyWifi Cloud
              </h2>
            </div>
            */}

            </div>
          </div>
          <div id="BuySection"></div>
        </section>
    );
  }
}

export default RentBanner;



// WEBPACK FOOTER //
// ./src/reusable/PurchaseDeviceBanner.js